import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from "react-helmet";
import IndexesListDisplay from './IndexesListDisplay';
import '../../css/blink.css';

class IndexesWrap extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>US Major Indexes Screener</title> 
          <link rel="canonical" href="https://www.vizfm.com/indices" />
          <meta name="description" content="All Majors Indexes (Dow Jones, Nasdaq, S&P 500) Screener" />
        </Helmet>
        <Container fluid className="p-2">
          <Row>
            <Col xs={3} sm={3} md={2} lg={1} xl={1}>
              <div className="waitingForConnection3">
                Live <i className="fa fa-asterisk"></i>
              </div>
            </Col>
            <Col xs={9} sm={9} md={10} lg={11} xl={11}>Indices Screener</Col></Row>
          <Row>
            <Col><IndexesListDisplay /></Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default IndexesWrap;
